import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  signContractsRequest,
  signContractRequest,
  fetchUnsignedContractsActions,
  fetchPendingContractsActions,
  selectAccountId,
  selectAccountRole,
  selectNextUnsignedContract,
  selectUnsignedInsuranceContract,
  selectToken,
} from '../../../../features/auth/ducks';
import { apiCallIds } from '../../../../features/auth/api';
import { connectModal } from '../../../../features/modal/hoc';
import { SignContractModal, SignLoanModal } from '../../../../common/modals';
import { getFileUrl } from '../../../../common/utils/helpers';
import { accountRoles, contractTypeT, contractType } from '../../../../common/enums';

const mapStateToProps = state => ({
  accountId: selectAccountId(state),
  accountRole: selectAccountRole(state),
  token: selectToken(state),
  contract: selectNextUnsignedContract(state),
  insuranceContract: selectUnsignedInsuranceContract(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      signContract: signContractRequest,
      signContracts: signContractsRequest,
      fetchUnsignedContracts: fetchUnsignedContractsActions.request,
      fetchPendingContracts: fetchPendingContractsActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
@connectModal(apiCallIds.SIGN_CONTRACT)
@translate()
export default class SignContract extends Component {
  static propTypes = {
    modalActions: PropTypes.object.isRequired,
    isVisible: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    actions: PropTypes.object.isRequired,
    accountId: PropTypes.string.isRequired,
    accountRole: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    token: PropTypes.string.isRequired,
    contract: PropTypes.object,
    children: PropTypes.node.isRequired,
    t: PropTypes.func.isRequired,
  };

  componentDidMount() {
    const { actions, accountId } = this.props;
    actions.fetchUnsignedContracts({ accountId });
    actions.fetchPendingContracts({ accountId });
  }

  onSubmitAll = e => {
    const { actions, accountId, contract, insuranceContract } = this.props;

    let contracts = []

    if (contract) {
      contracts.push(contract.id)
    }
    if (insuranceContract) {
      contracts.push(insuranceContract.id)
    }

    actions.signContracts({ accountId, contracts })
  };

  onSubmitGeneralContract = e => {
    const { actions, accountId, contract } = this.props;

    actions.signContract({ accountId, contractId: contract.id })
  };

  getFileLocation(contract) {
    const { token } = this.props;
    return contract ? getFileUrl(contract.fileId, token) : undefined;
  }

  renderModal() {
    const { modalActions, isLoading, t, contract, insuranceContract, accountRole } = this.props;

    const fileLocation = this.getFileLocation(contract);
    const insuranceFileLocation = this.getFileLocation(insuranceContract);

    if (contract.type === contractType.MANDATE) {
      return (
        <SignLoanModal
          isLoading={isLoading}
          onSubmit={this.onSubmitAll}
          modalActions={modalActions}
          fileLocation={fileLocation}
          insuranceFileLocation={insuranceFileLocation}
          withInsurance={!!insuranceContract}
        />
      );
    }

    if (contract.type === contractType.GENERAL) {
      const isInvestor = accountRole === accountRoles.CREDITOR || accountRole === 4 || accountRole === '4';
      const generalContractText = isInvestor
        ? t('Investor sa oboznámil so znením Rámcovej zmluvy (zmluva medzi Vami a prevádzkovateľom portálu Majak.sk, spoločnosť Peer2Peer, s.r.o.), rozumie jej, súhlasí s jej znením a berie na vedomie všetky jej účinky ako aj všetky práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo “Potvrdiť Rámcovú zmluvu” je táto zmluva pre investora v celom svojom rozsahu záväzná.')
        : t('Dlžník sa oboznámil so znením Rámcovej zmluvy (zmluva medzi Vami a prevádzkovateľom portálu Majak.sk, spoločnosť Peer2Peer, s.r.o.), rozumie jej, súhlasí s jej znením a berie na vedomie všetky jej účinky ako aj všetky práva a povinnosti z nej vyplývajúce. Je si vedomý, že kliknutím na tlačidlo “Potvrdiť Rámcovú zmluvu” je táto zmluva pre dlžníka v celom svojom rozsahu záväzná.');

      return (
        <SignContractModal
          isLoading={isLoading}
          onSubmit={this.onSubmitGeneralContract}
          hideModal={modalActions.hide}
          fileLocation={fileLocation}
          title={isInvestor ? t('Investorská rámcová zmluva') : contractTypeT.GENERAL}
          text={generalContractText}
          checkboxText={isInvestor ? t('Súhlasím s Investorskou rámcovou zmluvou') : t('Súhlasím s Rámcovou zmluvou')}
          buttonText={isInvestor ? t('Potvrdiť Investorskú rámcovú zmluvu') : t('Potvrdiť Rámcovú zmluvu')}
          fileLinktext={isInvestor ? t('Prečítať Investorskú rámcovú zmluvu') : t('Prečítať zmluvu')}
          showFileLink={!isInvestor}
        />
      );
    }
  }

  render() {
    const { children, isVisible, modalActions, contract } = this.props;
    const fileLocation = this.getFileLocation(contract);

    return (
      <span>
        {cloneElement(children, { onClick: modalActions.show })}
        {isVisible && fileLocation && this.renderModal()}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/dashboard/components/registration-action-alert/SignContract.js